/* eslint-disable @typescript-eslint/no-unused-vars */
import storeInfo from '../../ducks/store'
import { SiteVisitType } from './types'

export const getSiteVisit = () => (): SiteVisitType => {
  const { siteVisit } = storeInfo.store.getState()
  return siteVisit
}